import './styles.css';
import React from 'react';

const Planning = () => {
    return (
        <div className="context">
            <div className="contextTitle">학사일정</div>
            <hr className="titleSeparator" />

        </div>
    );
}

export default Planning;